module.exports = __webpack_public_path__ + "static/media/prd-cat-md-2.565fd560.jpg";